import React, { useState, useEffect, useRef } from 'react';
import './MemberPlateRecords.css';

import { PageTitle, ParkingItem } from '../../../components';
import { renderIcon } from '../../../utils';
import { memberFeatures } from '../../../constants';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import { MessageModal, ParkingInfo } from '../../../components';
import { getHistory } from '../../../constants';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';
import { useTokenCheck, getCurrentStatus } from '../../../constants';

const MemberPlateRecords = () => {

  const location = useLocation();
  const serviceSingle = location.state;

  // State to manage the active accordion for container 1
  const [activeAccordionId, setActiveAccordionId] = useState(null);

  // Function to handle accordion click event for container 1
  const handleAccordionClick = (id) => {
    setActiveAccordionId((prevId) => (prevId === id ? null : id));
  };

  const navigate = useNavigate();
  const [parkingRecords, setParkingRecords] = useState([]);
  const { nickName, isCanExecute } = useTokenCheck();
  const [name, setName] = useState('');
  const [parkingInfoData, setParkingInfoData] = useState([]);

  useEffect(() => {

    if (!isCanExecute) return;
    setName(nickName);

    getCurrentStatus().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;

      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          // 處理結果
          setParkingInfoData(payload.data);
        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage);
        }
      }
    }).catch(error => {
      console.error('Error during API call:', error);
    });

    getHistory().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;

      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          // 處理結果
          setParkingRecords(payload.data);
        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else if (payload.status === 1 && payload.errorCode === '9996') {
          //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
          let errorMessage = "查無此會員，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage);
        }
      }
    }).catch(error => {
      console.error('Error during API call:', error);
    });

  }, [isCanExecute]);


  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />
      {/* Page Title */}
      <PageTitle title={'會員中心'} page={'member center'} />

      <section className='service-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            {/* <SidebarHeading title={''} /> */}

            <div className='box-container'>
              {memberFeatures.map(memberFeatures => {
                return (
                  /* Link to the individual service page */
                  <Link
                    to={{
                      pathname: memberFeatures.link,
                    }}
                    location={{ memberFeatures }}
                    state={memberFeatures}
                    key={memberFeatures.id}
                    className='item'><span><div className='icon'>{renderIcon(memberFeatures.title)}</div>{memberFeatures.title}</span> {/* Service Title */}
                  </Link>)
              })}
            </div>

          </div>

        </div>

        <div className='service-info'>

          <div className='content'>

            <h3 className='main-heading'>目前停車</h3>

            <ParkingInfo parkingRecords={parkingInfoData} emptyMessage={'目前沒有需要繳費的紀錄'} />

            {/* Service heading */}
            <h3 className='main-heading'>繳費查詢(三個月內記錄)</h3>

            {!parkingRecords || parkingRecords.length === 0 &&

              <div className='messageBox'>
                <div className='box'>
                  {/* 空白的停車資訊 */}
                  <div className='emptyParkingInfo'>{'目前沒有歷史紀錄'}</div>
                </div>
              </div>
            }
            {parkingRecords && parkingRecords.length > 0 &&

              parkingRecords.map((item, index) => (
                <ParkingItem
                  key={item.plate + "_" + index}
                  id={item.plate + "_" + index}
                  enterTime={item.enterTime}
                  lotName={item.lotName}
                  plateNo={item.plateNo}
                  remain={item.remain}
                  categoryList={item.categoryList}
                  discountsList={item.discountsList}
                  isActive={item.plate + "_" + index === activeAccordionId}
                  onAccordionClick={handleAccordionClick}
                />
              ))
            }

          </div>
        </div>

      </section>
    </>
  );
}

export default MemberPlateRecords;
